/**
 * 16-hex-char id generator. Matches `random64BitHexString()` in
 * yoto-web (`resources/assets/js/src/analytics/analytics-core.ts`) so the
 * resulting IDs are interchangeable with the rest of the analytics fleet.
 *
 * Implementation prefers `crypto.randomUUID()` (modern, cryptographically
 * strong) and falls back to `Math.random()` if unavailable.
 */

export function random64BitHex(): string {
  const c = typeof crypto !== 'undefined' ? crypto : undefined;
  if (c?.randomUUID) {
    return c.randomUUID().replace(/-/g, '').slice(0, 16);
  }
  if (c?.getRandomValues) {
    const buf = new Uint8Array(8);
    c.getRandomValues(buf);
    return Array.from(buf, (b) => b.toString(16).padStart(2, '0')).join('');
  }
  // Last-resort fallback. Still returns 16 hex chars; not crypto-strong.
  let out = '';
  while (out.length < 16) {
    out += Math.floor(Math.random() * 0xffffffff).toString(16).padStart(8, '0');
  }
  return out.slice(0, 16);
}
